module.exports = __webpack_public_path__ + "resources/img/img_goldilocks.f3c0d5ba5f8680259855378e6721eee3.png";